import { cn } from '@/lib/utils';

import type { RegistryType } from '../types';

interface RegistryBadgeProps {
  registry: RegistryType | string;
}

export function RegistryBadge({ registry }: RegistryBadgeProps) {
  return (
    <span
      className={cn(
        // Monochrome theme: registry is a category, not a status — neutral chip.
        'inline-flex items-center px-2 py-0.5 text-xs font-medium',
        'bg-accent-soft text-ink'
      )}
    >
      {registry}
    </span>
  );
}
